import api from './api';
import apiWithRefreshToken from './apiWithRefreshToken';

const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;
const API_BASE_URL_REWRITE =
  process.env.NEXT_PUBLIC_BASE_URL_REWRITE || process.env.NEXT_PUBLIC_BASE_URL;

const getListBranch = (payload, isUseGatewayAPI?) =>
  api.get(
    `content/v1/branch`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT, params: payload } : { params: payload },
    false,
    false,
    false
  );

const getListFaq = () => api.get(`content/v1/faq?type=CONTENT&code=${5}`, {}, false, false, false);

const getListFaqByCity = ({ city = '', isLandingPage = '' }, isUseGatewayAPI?: boolean) =>
  api.get(
    `content/v1/faq?type=CITY&code=${city}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getListReview = (payload, isUseGatewayAPI?: boolean) =>
  api.get(
    `content/v1/review?type=city&code=${payload.city}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getDetailBranch = (payload, isUseGatewayAPI?) =>
  api.get(
    `content/v1/branch/branch-detail/${encodeURIComponent(payload.slug)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getFaqByBranchSlug = ({ branchSlug = '', isLandingPage = '' }, isUseGatewayAPI?: boolean) =>
  api.get(
    `content/v1/faq?type=BRANCH&code=${encodeURIComponent(
      branchSlug
    )}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getListBranchRecommended = async (payload = {}) => {
  const response = await apiWithRefreshToken.get(`/api/recommend-branch`, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    params: payload,
  });

  return response.data;
};

const getListBranchIsoCodeV2 = (code: string, params: URLSearchParams | null = null) => {
  return api.get(
    `content/v1/branch/get-branch-list/city/${code}${params && `?${params.toString()}`}`,
    { baseURL: API_BASE_URL_REWRITE },
    false,
    false,
    false
  );
};

export default {
  getListBranch,
  getListFaq,
  getListFaqByCity,
  getListReview,
  getDetailBranch,
  getFaqByBranchSlug,
  getListBranchRecommended,
  getListBranchIsoCodeV2,
};
